/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestIoTestMessageSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_IO_TEST_MESSAGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AutoTestIoTestMessageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestIoTestMessageSettingParser.decode(input).map(res => new AutoTestIoTestMessageSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestIoTestMessageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestIoTestMessageSettingParser.encode(data);
    }
    static schema() {
        return AutoTestIoTestMessageSettingParser.schema();
    }
}
